import * as Yup from "yup";

export const planSchema = Yup.object().shape({
  name: Yup.string()
    .max(255, "Nome deve ter no máximo 255 caracteres")
    .required("Nome é obrigatório"),

  //category_id: Yup.number()
  //.nullable()
  //.typeError('Categoria inválida'),

  payment_method_id: Yup.string().required("Forma de pagamento é obrigatória"),

  limit: Yup.number().nullable().typeError("Limite deve ser um número"),

  days: Yup.string()
    .required("Informe os dias")
    .test("is-valid-json", "Formato de dias inválido", (value) => {
      if (!value) return false;
      try {
        const obj = JSON.parse(value);
        const keys = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ];
        // Tem que ser objeto, com as 7 chaves e valores booleanos
        if (typeof obj !== "object" || obj === null) return false;
        for (const key of keys) {
          if (!(key in obj)) return false;
          if (typeof obj[key] !== "boolean") return false;
        }
        return true;
      } catch {
        return false;
      }
    }),

  value: Yup.mixed().nullable().typeError("Valor inválido"),

  change_existing_registration_price: Yup.boolean().nullable(),

  description: Yup.string().nullable(),

  service: Yup.array()
    .of(
      Yup.object().shape({
        service_id: Yup.string().required("Serviço é obrigatório"),

        duration: Yup.number()
          .transform((value, originalValue) =>
            String(originalValue).trim() === "" ? undefined : value,
          )
          .min(1, "Duração deve ser no mínimo 1 minuto")
          .required("Duração é obrigatória"),

        points: Yup.number()
          .min(0, "Pontos devem ser zero ou mais")
          .nullable()
          .typeError("Pontos devem ser um número"),
      }),
    )
    .min(1, "É necessário ao menos um serviço")
    .required("Serviços são obrigatórios"),
});
